{
  "serviceForms": {
    "claimMissingAvios": {
      "departureDate": {
        "label": "Departure date",
        "max": "You cannot claim Avios in advance",
        "min": "You can claim Avios from flights between two weeks and six months since the date of travel",
        "pattern": "Please enter the date in the following format: DD.MM.YYYY",
        "placeholder": "dd.mm.yyyy",
        "required": "Departure date is required",
        "selection": "You have selected: Day: {day}. Month: {month}. Year: {year}."
      },
      "error": {
        "aviosAlreadyGiven": "Avios already granted for the ticket",
        "genericError": "Something went wrong, please try again later or fill in more details below so that we can process your claim for missing Avios.",
        "marketingCarrierIsInvalidForLoyalty": "This flight does not entitle to Avios.",
        "memberNotFound": "Member not found",
        "memberNotPartOfTicket": "Member cannot be found from the ticket",
        "passengerDidNotFlyOnThisFlightDate": "This flight does not entitle to Avios as ticket is not used.",
        "passengerIsAnIdPassenger": "This flight does not entitle to Avios.",
        "passengerIsNoShowForThisFlightDate": "This flight does not entitle to Avios as ticket is not used.",
        "passengerNameNotFound": "Something went wrong: name is not matching. Please try again later or fill in more details below so that we can process your claim for missing Avios.",
        "requestNotEligibleAnymore": "It's too late to add the Avios. You can add missing Avios up to 6 months after the last flight in the ticket was flown.",
        "requestNotYetEligibleProcessingDelayNotReached": "It's too early to add the missing Avios. Please wait 10 days after the last flight to claim Avios.",
        "thisFlightIsACharterFlight": "This flight does not entitle to Avios.",
        "thisFlightIsAnAdhocFlight": "This flight does not entitle to Avios.",
        "thisFlightWasAlreadyAccrued": "Avios were already accrued.",
        "thisFlightWasAlreadyAccruedForAnotherFrequentFlyerCard": "Avios were already accrued to another frequent flyer account.",
        "thisPassengerUsedARedemptionTicket": "This flight does not entitle to Avios.",
        "ticketNotFound": "Ticket not found for the given ticket number"
      },
      "flightDate": {
        "label": "Flight date",
        "max": "You cannot claim Avios in advance",
        "min": "You can claim Avios from flights between two weeks and six months since the date of travel",
        "pattern": "Please enter the date in the following format: DD.MM.YYYY",
        "placeholder": "dd.mm.yyyy",
        "required": "Flight date is required. Please enter the date in the following format: DD.MM.YYYY",
        "selection": "You have selected: Day: {day}. Month: {month}. Year: {year}."
      },
      "flightNumber": {
        "label": "Flight number",
        "pattern": "Please enter your flight number without the airline code.",
        "placeholder": "E.g. 41",
        "required": "Flight number is required."
      },
      "helpLink": "Important information",
      "helpModal": {
        "localSettings": {},
        "url": "/en/important-information-3309026"
      },
      "helpTitle": "Important information",
      "loggedInFlightsIntro": "<p><b>You can claim Avios retroactively between 2 weeks–6 months</b> after the travel date of your flights with Finnair or scheduled flights with our partner airlines.</p>",
      "loginPromotion": {
        "description": "As a Finnair Plus member, you can claim Avios from your flight by filling in the form after logging in.",
        "footerText": "You will be redirected back to this page after logging in.",
        "loginHeading": "Log in to your account to claim missing Avios"
      },
      "notLoggedInFlightsIntro": "<p><b>You can claim Avios retroactively between 2 weeks–6 months</b> after the travel date of your Finnair flights or scheduled flights with our partner airlines. The same retroactive claim period applies to transactions with Finnair Plus partners such as hotels, car rental companies and other services.</p>",
      "partnerIntro": "<p><b>If you want to claim Avios from your flights, click the ‘From flights’ tab.</b></p><p>You can retroactively claim missing Avios for your transactions with <b>Finnair Plus partners such as hotels, car rental companies and other services</b> by filling in your information <b>in the form below</b>.</p><p>Please note that you should include a copy of the rental agreement or a hotel invoice as an attachment.</p><p>The rules for collecting Avios may be different with some Finnair Plus partners. Find more information about possible limitations from <a href=\"https://www.finnairshop.com/en/finnair-plus-awards-and-products\" target=\"_blank\">Finnair Shop.</a></p>",
      "returnDate": {
        "label": "Return date",
        "max": "You cannot claim Avios in advance",
        "min": "You can claim Avios from flights between two weeks and six months since the date of travel",
        "pattern": "Please enter the date in the following format: DD.MM.YYYY",
        "placeholder": "dd.mm.yyyy",
        "required": "Return date is required",
        "selection": "You have selected: Day: {day}. Month: {month}. Year: {year}."
      },
      "ticketNumber": {
        "label": "Ticket number",
        "pattern": "Ticket number should contain 13 numbers",
        "required": "Ticket number is required"
      },
      "ticketNumberHelpModal": {
        "localSettings": {},
        "url": "/en/ticket-number-on-electronic-ticket-receipt-2778512"
      },
      "ticketNumberHelpTitle": "Ticket number"
    }
  }
}
